import cookies from "browser-cookies"
import axios from "axios"
import addOrderTagging from "./order/order-confirmation"
import { nostojs } from "./api"

export function sendCartTokenFromShopifyCookie() {
  const cartToken = cookies.get("cart")
  sendTokens(cartToken)
  addOrderTagging()
}

export function sendCartToken(cartToken: string | null) {
  if (!cartToken) {
    sendCartTokenFromShopifyCookie()
  }
  sendTokens(cartToken)
  addOrderTagging()
}

export async function checkTokenToCustomer() {
  const cartToken = cookies.get("cart")
  if (!cartToken && window?.Shopify) {
    try {
      const token = await updateCartToken()
      sendTokens(token)
    } catch (e) {
      console.error("Nosto: error updating cart:", e)
    }
  }
}

async function updateCartToken() {
  const response = await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({})
  })
  if (!response.ok) {
    throw new Error(`Failed to update cart: [${response.status}] ${response.statusText}`)
  }
  const data = await response.json<{ token: string }>()
  return data.token
}

function sendTokens(cartToken: string | null) {
  nostojs(async api => {
    const customerId = api.visit.getCustomerId()
    const nostoSettings = api.internal.getSettings()
    if (cartToken && customerId) {
      await axios.get(`${nostoSettings.server}/token/${nostoSettings.account}/${customerId}/${cartToken}`)
    }
  })
}
